import QorusClient from "@/api/clients/QorusClient";
import MiscClient from "@/api/clients/MiscClient";
import qs from "qs";
import { hereAddress } from "@/models/relais";
import Api from "@/api/Api";
import { AxiosRequestConfig } from "axios";

export default class PlatformApi {
  static of(): PlatformApi {
    return new PlatformApi();
  }

  configureEmpowerment(form, pncList): Promise<any> {

    const data = new FormData();
    data.append("monthlyBudgetAmount", form.monthlyBudgetAmount);
    data.append("month", form.date.month);
    data.append("year", form.date.year);

    if (pncList) {
      data.append("pncList", pncList);
    }

    const axiosRequestConfig: AxiosRequestConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    return QorusClient.client.post("empowerment/setup", data, axiosRequestConfig).then(
      (data) => {
        return data;
      },
      (data) => {
        throw data;
      },
    );
  }

  getEmpowermentBalance(): Promise<any> {
    return QorusClient.client.get("empowerment/money-pot/current").then(
      (data) => {
        return data;
      },
      (data) => {
        throw data;
      },
    );
  }

  getApiColissimo(info): Promise<any> {
    const date = new Date();

    const shippingDate = new Date(date.setDate(date.getDate() + 2)).toLocaleDateString("fr-FR");

    const params = {
      address: info.address.street,
      countryCode: info.address.country,
      zipCode: info.address.postCode,
      city: info.address.city,
      weight: info.weight,
      shippingDate,
    };

    return QorusClient.client.post("colissimo/relays", params).then(
      (data) => {
        return data;
      },
      (data) => {
        throw data;
      },
    );
  }

  checkRecaptcha(token): Promise<any> {

    return QorusClient.client.post("google/recaptcha", {
      "response": token,
      "remoteip": Api.payment.getIP(),
    }).then(
      (data) => {
        return data;
      },
      (data) => {
        throw data;
      },
    );
  }

  reverseGeocoding(geocode): Promise<any> {

    return MiscClient.of().get("https://revgeocode.search.hereapi.com/v1/revgeocode", {
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false });
      },
      params: {
        "at": geocode.lat + "," + geocode.lng,
        "lang": "fr-FR",
        "apiKey": process.env.VUE_APP_HERE_API,
      },
    }).then(
      (data) => {
        return hereAddress.of(data.items[0].address);
      },
      (data) => {
        throw data;
      },
    );
  }

  formatAddress(address): Promise<any> {

    return MiscClient.of().get("https://places.cit.api.here.com/places/v1/suggest", {
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false });
      },
      params: {
        "q": address.street + " " + address.postCode + " " + address.city + " " + address.country,
        "X-Map-Viewport": "13.3704,52.5122,13.4194,52.5262",
        "apiKey": process.env.VUE_APP_HERE_API,
      },
    }).then(
      (data) => {
        return data.suggestions[0];
      },
      (data) => {
        throw data;
      },
    );
  }

  geocode(address): Promise<any> {

    return MiscClient.of().get("https://geocode.search.hereapi.com/v1/geocode", {
      paramsSerializer: function (params) {
        return qs.stringify(params, { indices: false });
      },
      params: {
        "q": address.street + " " + address.postCode + " " + address.city + " " + address.country,
        "limite": 1,
        "apiKey": process.env.VUE_APP_HERE_API,
      },
    }).then(
      (data) => {
        if (data.items.length > 0) {
          return { lat: data.items[0].position.lat, lng: data.items[0].position.lng };
        }
        return null;
      },
      (data) => {
        throw data;
      },
    );
  }

  submitContactForm(form): Promise<any> {

    return QorusClient.client.post("platform/contact", form).then(
      (data) => {
        return data;
      },
      (data) => {
        throw data;
      },
    );
  }

  getTermsOfUse(): Promise<any> {
    return QorusClient.client.get("platform/terms-of-use").then(
      (data) => {
        return data;
      },
      (data) => {
        throw data;
      },
    );
  }

  getLegalMentions(): Promise<any> {
    return QorusClient.client.get("platform/legal-mentions").then(
      (data) => {
        return data;
      },
      (data) => {
        throw data;
      },
    );
  }
}